import { ApplicationPrefix } from '@openx/constants/paths';
import { isPathInApp } from '@openx/utils/lib/isPathInApp';
import type { JSX, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorComponent, type ErrorProps } from '../Error/Error';
import { FailureImage } from '../Error/pictures/Failure';

interface GeneralErrorProps extends Partial<ErrorProps> {
  onClick: (ev: SyntheticEvent<HTMLButtonElement>) => void;
  'data-test'?: string;
}

export function GeneralError(props: GeneralErrorProps): JSX.Element {
  const { actions, subtitle, titlePrefix, title } = props;
  const { t } = useTranslation();
  const pathname = window.location.pathname;

  const getPageTitle = () => {
    if (isPathInApp(pathname, ApplicationPrefix.Dsp)) {
      return 'DSP UI';
    }

    if (isPathInApp(pathname, ApplicationPrefix.Publisher)) {
      return 'OXControl';
    }

    return 'Unity';
  };

  return (
    <ErrorComponent
      titlePrefix={titlePrefix || getPageTitle()}
      title={title || t('Ooops!')}
      subtitle={subtitle || t('Something went wrong. Please refresh your browser.')}
      PictureComponent={FailureImage}
      data-test={props['data-test'] || 'general-error'}
      actions={
        actions || [
          {
            children: t('Refresh'),
            color: 'secondary',
            'data-test': 'button-refresh',
            onClick: props.onClick,
            variant: 'contained',
          },
        ]
      }
    />
  );
}
